module.exports = __webpack_public_path__ + "static/media/brand-refresh-radio-off.01dbf51f.svg";